var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransactionImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 54,
    viewBox: "0 0 59 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 59,
    height: 54,
    rx: 10,
    fill: "#EF6F6F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.3742 14.634L33.5749 13.1516C33.193 12.9495 32.7373 12.9495 32.3555 13.1516L29.5572 14.6334C29.2676 14.7866 28.9221 14.7866 28.6325 14.6335L25.834 13.1516C25.4522 12.9495 24.9965 12.9495 24.6147 13.1516L21.8151 14.634C21.5283 14.7858 21.185 14.7871 20.897 14.6375L18.1892 13.2297V33.7629H32.2953C32.685 33.7629 33.0011 34.0788 33.0011 34.4687V38.8794C33.0011 40.8091 34.571 42.3789 36.5006 42.3789C38.4303 42.3789 40.0001 40.809 40.0001 38.8794V13.2299L37.2924 14.6377C37.0041 14.7874 36.6609 14.7861 36.3741 14.6341L36.3742 14.634ZM22.36 19.3094H29.5147C29.9044 19.3094 30.2205 19.6253 30.2205 20.0152C30.2205 20.405 29.9044 20.721 29.5147 20.721H22.36C21.9703 20.721 21.6542 20.405 21.6542 20.0152C21.6542 19.6253 21.9702 19.3094 22.36 19.3094ZM35.161 30.249H22.36C21.9703 30.249 21.6542 29.9331 21.6542 29.5432C21.6542 29.1534 21.9703 28.8374 22.36 28.8374H35.161C35.5507 28.8374 35.8668 29.1534 35.8668 29.5432C35.8668 29.9329 35.5507 30.249 35.161 30.249ZM35.161 25.3086H22.36C21.9703 25.3086 21.6542 24.9926 21.6542 24.6028C21.6542 24.213 21.9703 23.897 22.36 23.897H35.161C35.5507 23.897 35.8668 24.213 35.8668 24.6028C35.8668 24.9925 35.5507 25.3086 35.161 25.3086Z",
    fill: "#EE6666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7764 42.3782H33.0597C32.1532 41.4867 31.5898 40.2474 31.5898 38.8787V35.1738H13.2769V38.8787C13.2769 40.8083 14.8469 42.3782 16.7763 42.3782H16.7764Z",
    fill: "#EE6666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionImage);
export default __webpack_public_path__ + "static/media/transaction_image.8e3e234c939edccba55d96659bfe3025.svg";
export { ForwardRef as ReactComponent };